<template>
    <v-container fluid class="fill-height pa-0" width="100%">
        <v-card min-height="100vh" color="white" width="100%">
            <v-toolbar color="amber">
                <v-btn icon @click="Close"> <v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title class="font-weight-black" v-if="edit == true">Edit Product</v-toolbar-title>
                 <v-toolbar-title class="font-weight-black" v-else>New Product</v-toolbar-title>
                    <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-switch v-model="statusHere" :label="statusHere == true ? 'Active': 'In Active'" :value="true" color="black" class="mr-5 mt-5"></v-switch>
                    <v-btn color="black" class="amber--text" @click="Save()" :loading="isLoading">Save</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-form class="pa-5">
                <v-row dense>
                    <v-col lg=4 md=4 sm=6 cols=12>
                        <v-text-field v-model="name" label="Product Name" color="amber" outlined></v-text-field>
                    </v-col>
                    <v-col lg=4 md=4 sm=6 cols=12>
                        <v-select :items="[{name:'Sales',value:'sale'},{name:'Purchase',value:'purchase'}]" item-text="name" item-value="value" v-model="nature" label ="Select Product Nature" color="amber" outlined ></v-select>
                    </v-col>
                    <v-col lg=4 md=4 sm=6 cols=12>
                        <v-select :items="[{name:'Oil %',value:'Oilper'},{name:'Bag',value:'bag'},{name:'LoseRate',value:'looserate'}]" item-text="name" item-value="value" v-model="aConditions" label ="Select Product's Condition" color="amber" outlined ></v-select>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col lg=4 md=4 sm=6 cols=12>
                        <v-text-field v-model="preFix" label="Product PreFix" color="amber" outlined></v-text-field>
                    </v-col>
                    <v-col lg=4 md=4 sm=6 cols=12>
                        <v-select :items="nature == 'sale' ? ['SaleFormA','SaleFormB'] : nature == 'purchase' ?  ['PurchaseFormA','PurchaseFormB','PurchaseFormC'] : []" v-model="pF" label ="Select Product Form" color="amber" outlined ></v-select>
                    </v-col>
                    <v-col lg=4 md=4 sm=6 cols=12>
                         <v-text-field v-model="productOrder" label="Product Order" type="number" color="amber" outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col lg=8 md=8 sm=12 cols=12>
                        <vue-editor v-model="tC" placeholder="Term & Conditions"></vue-editor>
                        <!--<v-text-field v-model="tC" label="Term & Condition" color="amber" outlined></v-text-field>-->
                    </v-col>
                </v-row>
            </v-form>
        </v-card>
        <span style="display:none">{{checkFetch}}</span>
    </v-container>
</template>

<script>
import { SERVER_API } from '../../API';
import { VueEditor } from "vue2-editor";
export default {
    created(){
        window.addEventListener('keyup', event => {
            if(event.which === 27){
                this.Close();
            }
            if(event.which === 13){
                this.Save();
            }
        })
    },
    props:['id','edit'],
    components: {VueEditor},
    data(){
        return{
            name:'',
            nature:'',
            preFix:'',
            pF:'',
            tC:'',
            isLoading:false,
            productOrder:'',
            status:0,
            aConditions:'',
            statusHere:false,
        }
    },
    watch:{
        statusHere(val){
            if(val == true){
                this.status = 1;
            }else{
                this.status = 0;
            }
        }
    },
    computed:{
        checkFetch(){
            return this.fetchById();
        }
    },
    methods:{
        Close(){
            this.Reset()
            this.id = '';
            this.edit="";
            this.$emit('Close',false);
        },
        Reset(){
            this.name = "";
            this.nature = "";
            this.preFix = "";
            this.productOrder = "";
            this.pF = "";
            this.tC = "";
            this.aConditions = "";
        },
       async fetchById(){
            if(this.edit == true){
                try{
                    const response = await this.$http.get(SERVER_API+'/product/byid/'+this.id);
                    this.name = response.data.data.name;
                    this.nature = response.data.data.nature;
                    this.preFix = response.data.data.preFix;
                    this.pF = response.data.data.pF;
                    this.tC = response.data.data.tC;
                    this.aConditions = response.data.data.aConditions;
                    this.status = response.data.data.status;
                    this.productOrder = response.data.data.productOrder,
                    this.statusHere = response.data.data.status == 1 ? true : false;
                }catch(error){
                    alert('Unable to Fetch Data BY Watch Method using Product Id. Error is:'+error);
                }
            }
        },
        async Save(){
            if(this.edit == true){
                try{
                    this.isLoading = true;
                    const response = await this.$http.put(SERVER_API+'/product/update',{
                        id:this.id,
                        name: this.name,
                        nature: this.nature,
                        preFix: this.preFix,
                        pF: this.pF,
                        tC: this.tC,
                        aConditions: this.aConditions,
                        productOrder: this.productOrder,
                        status: this.status,
                    });
                    this.isLoading = false;
                    this.$emit('Response', response.data);                                
                }catch(error){
                    this.isLoading = false;
                    this.$emit('Response', error);
                }
                
            }else{
                try{
                    this.isLoading = true;
                    const response = await this.$http.post(SERVER_API+'/product/create',{
                        name: this.name,
                        nature: this.nature,
                        preFix: this.preFix,
                        pF: this.pF,
                        tC: this.tC,
                        aConditions:this.aConditions,
                        productOrder:this.productOrder,
                        status: this.status,
                    });
                    this.isLoading = false;
                    this.Reset()
                    this.$emit('Response', response.data);                                
                }catch(error){
                    this.isLoading = false;
                    this.$emit('Response', error);                    
                }
            }
        }
    }

}
</script>

<style>

</style>